









import { Component, Prop, Emit, Vue } from "vue-property-decorator";

interface SimbarDatePicker {
    now: Date;
}

@Component({
    name: "SimbarDatePicker",
    inheritAttrs: false
})
class SimbarDatePicker extends Vue {
    @Prop({ type: [String, Date] })
    public readonly value!: string | Date;

    @Prop({ type: Boolean, default: false })
    public readonly disabled!: boolean;

    @Prop({ type: String, default: "" })
    public readonly id!: string;

    @Prop({ type: Boolean, default: true })
    public readonly resetButton!: boolean;

    public get attrs() {
        let attrs: any = {
            labelTodayButton: "Selecionar hoje",
            labelResetButton: "Limpar",
            labelCloseButton: "Fechar",
            labelPrevDecade: "Década anterior",
            labelPrevYear: "Ano anterior",
            labelPrevMonth: "Mês anterior",
            labelCurrentMonth: "Mês atual",
            labelNextMonth: "Próximo mês",
            labelNextYear: "Próximo ano",
            labelNextDecade: "Próxima década",
            labelToday: "Hoje",
            labelSelected: "Data selecionada",
            labelNoDateSelected: "Nenhuma data selecionada",
            labelCalendar: "Calendário",
            labelNav: "Navegação do calendário",
            labelHelp: "Use as setas do teclado para navegar entre datas",
            placeholder: "Data...",
            locale: "pt-BR",
            resetButton: true,
            resetButtonVariant: "outline-secondary",
            dateFormatOptions: {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            },
            class: "w-100",
            max: this.now
        };
        if (this.id !== "") {
            attrs.id = this.id;
        }
        attrs = {
            ...attrs,
            ...this.$attrs
        };
        return attrs;
    }

    @Emit()
    input(value: string) {
        return value;
    }

    created() {
        this.now = new Date();
    }
}

export default SimbarDatePicker;
